import React from 'react'
import * as Yup from 'yup'
import { withFormik } from 'formik'
import { Input, TextErrorInput, Button } from '@provi/provi-components'
import { Form } from '../../../components/form'

export const Formik = props => {
  const { handleChange, values, errors, touched, handleBlur, handleSubmit } = props

  return (
    <Form onSubmit={handleSubmit}>
      <Input
        autoFocus
        margin="normal"
        id="courseAfter"
        placeholder="Escreva aqui"
        onChange={handleChange('courseAfter')}
        onBlur={handleBlur('courseAfter')}
        error={!!errors.courseAfter}
        value={values.courseAfter}
      />
      {errors.courseAfter && touched.courseAfter && <TextErrorInput text={errors.courseAfter} />}

      <Button
        marginHorizontal={0}
        type="submit"
        disabled={errors.courseAfter || !values.courseAfter}
        text="Avançar"
        persistFloatingMode={false}
      />
    </Form>
  )
}

export const FormFomik = withFormik({
  validateOnBlur: false,
  validateOnChange: true,
  enableReinitialize: true,
  mapPropsToValues: props => ({ courseAfter: props.data || '' }),
  validationSchema: Yup.object().shape({
    courseAfter: Yup.string()
      .min(5, 'A resposta deve conter no mínimo 5 caracteres')
      .max(2048, 'A resposta deve conter no máximo 2048 caracteres')
      .required('Digite um texto válido')
  }),
  handleSubmit: async ({ courseAfter }, { setSubmitting, props }) => {
    props.goToNextScreen(courseAfter)
    setSubmitting(false)
  }
})(Formik)
